module.exports = __webpack_public_path__ + "static/media/home-icon.ed9a9ea3.svg";